export const ar = {
  brand: "OrderHub",
  linkHint: "إذا لم يعمل الزر أعلاه، انسخ والصق الرابط في متصفحك:",
};